import {ChangeDetectionStrategy, Component} from '@angular/core';

/**
 * Panel Component
 *
 * @ngModule PanelsModule
 */
@Component({
  selector: 'maia-panel-title-extra-action',
  template: '<ng-content></ng-content>',
  styleUrls: ['./panel-title-extra-action.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelTitleExtraActionComponent {}
